<template>
  <div class="app" id="login-page">
    <div class="login-form">
      <div class="content-w3ls">
        <div class="content-agile1">
          <div class="content-logo">
            <img src="../../img/logo.png" alt="logo" />
            <h3>TRANG QUẢN TRỊ</h3>
          </div>
        </div>
        <div class="content-agile2">
          <div class="title-login text-center form-login">
            Đăng nhập
            <div v-if="mData.showError" class="alert">
              <div>
                <i class="fa-solid fa-stopwatch" />
                <span class="alert__danger">{{
                  mData.timeRemainingNumber
                }}</span>
              </div>
            </div>
          </div>
          <div style="min-height: 349px">
            <el-form
              ref="myForm"
              :model="mData.dataForm"
              :rules="mData.validForm"
              label-width="120px"
              label-position="top"
              @submit.native.prevent
            >
              <el-form-item label="Tên đăng nhập" prop="account">
                <el-input
                  v-model="mData.dataForm.account"
                  size="medium"
                  clearable
                  @input="forceUpdateUI"
                  autofocus
                ></el-input>
              </el-form-item>
              <el-form-item label="Mật khẩu" prop="password">
                <el-input
                  type="password"
                  size="medium"
                  v-model="mData.dataForm.password"
                  show-password
                  @input="forceUpdateUI"
                ></el-input>
              </el-form-item>
              <el-form-item label prop="remember">
                <b-row class="mt-1">
                  <b-col cols="6" class="remember-pass">
                    <el-checkbox v-model="mData.dataForm.remember">
                      Nhớ mật khẩu</el-checkbox
                    >
                  </b-col>
                  <!-- Mở ra khi api hoàn thiện luồng lấy code qua email -->
                  <!-- <b-col cols="6" class="text-right">
                    <a
                      @click="fn_recoverPassword()"
                      class="forgot-pass text-primary"
                      >Khôi phục mật khẩu</a
                    >
                  </b-col> -->
                </b-row>
              </el-form-item>
              <el-form-item class="form-btn">
                <el-button
                  class="btnLogin"
                  native-type="submit"
                  v-ladda
                  @click="fn_submitForm()"
                  >Đăng nhập</el-button
                >
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AuthService from "../../service/AuthService";
import LanguageService from "../../service/LanguageService";
import ValidService from "../../service/ValidService";
import MethodService from "../../service/MethodService";

export default {
  data() {
    return {
      aLang: LanguageService.vi,
      mData: {
        showError: false,
        countLogin: 0,
        messageError: "",
        timeRemainingLeft: "",
        timeRemainingNumber: "",
        setTitmeoutCalcTimeReamining: null,
        dataForm: {
          account: "",
          password: "",
          remember: true,
        },
        validForm: {
          account: [ValidService.required],
          password: [ValidService.required],
        },
      },
    };
  },
  methods: {
    forceUpdateUI() {
      this.$forceUpdate();
    },
    closeAlert() {
      this.mData.showError = false;
    },
    calcTimeRemaining(timeLock, timeRelease) {
      let timeL;
      if (new Date().getTime() < new Date(timeLock).getTime()) {
        timeL = new Date(timeLock).getTime();
      } else timeL = new Date().getTime();
      const timeR = new Date(timeRelease).getTime();
      const timeRemaining = timeR - timeL;

      if (timeRemaining <= 0) {
        this.mData.showError = false;
        return;
      }
      const minute = new Date(timeRemaining).getMinutes();
      const second = new Date(timeRemaining).getSeconds();
      const minuteFormat = minute < 10 ? `0${minute}` : minute;
      const sencodFormat = second < 10 ? `0${second}` : second;
      this.mData.timeRemainingLeft = `${minute} phút ${sencodFormat} giây`;
      this.mData.timeRemainingNumber = `${minuteFormat}:${sencodFormat}`;
      this.mData.setTitmeoutCalcTimeReamining = setTimeout(() => {
        this.calcTimeRemaining(timeLock, timeRelease);
      }, 1000);
    },
    clearTimeOut() {
      if (this.mData.setTitmeoutCalcTimeReamining)
        clearTimeout(this.mData.setTitmeoutCalcTimeReamining);
    },
    fn_submitForm() {
      this.$refs["myForm"].validate((valid) => {
        if (!valid) return false;
        AuthService.login(
          this.mData.dataForm.account,
          this.mData.dataForm.password,
          this.mData.dataForm.remember
        )
          .then(() => {
            // kiểm tra roles thuộc family không cho phép đăng nhập
            AuthService.me()
              .then(async (res) => {
                window.localStorage.setItem(
                  "currentUser",
                  JSON.stringify(res.result)
                );

                let localCurrentUser = localStorage.getItem("currentUser");
                if (
                  JSON.parse(localCurrentUser).roles.indexOf("FamilyAdmin") ===
                    0 ||
                  JSON.parse(localCurrentUser).roles.indexOf("FamilyUser") ===
                    0 ||
                  JSON.parse(localCurrentUser).roles.indexOf(
                    "FamilyModerator"
                  ) === 0
                ) {
                  window.toastr.error(alang.user_account_error);
                  MethodService.stopLadda();
                  AuthService.logout(false)
                    .then(() => {
                      next("/auth/login");
                      window.localStorage.clear();
                    })
                    .catch();
                } else {
                  if (this.$route.query.redirect) {
                    this.$router.push({ path: this.$route.query.redirect });
                  } else this.$router.push({ name: "Admin-Home" });
                }
              })
              .catch((e) => {
                console.log(e);
                window.localStorage.clear();
                MethodService.stopLadda();
              });
          })
          .catch((error) => {
            console.log(error);
            if (
              (error.code === 37000 && error.meta.locked) ||
              error.code === 37001
            ) {
              this.clearTimeOut();
              this.mData.showError = true;
              this.calcTimeRemaining(
                error.meta.lockedTime,
                error.meta.releaseTime
              );
              this.mData.messageError = `Tài khoản đã bị khóa do nhập sai quá số lần quy định.
                                      Tài khoản sẽ được mở sau ${this.mData.timeRemainingLeft}`;
            } else if (error.code === 37000) {
              this.clearTimeOut();
              this.closeAlert();
              this.mData.countLogin = error.meta.remainingCount;
              this.mData.messageError = `Tài khoản hoặc mật khẩu bị sai, còn ${
                error.meta.remainingCount ? error.meta.remainingCount : 0
              } lần đăng nhập`;
            } else {
              this.mData.messageError = error.message;
            }
            window.toastr.warning(this.mData.messageError);
            MethodService.stopLadda();
          });
      });
    },
    fn_recoverPassword() {
      this.$router.push({ name: "Auth-RecoverPassword" });
    },
  },
};
</script>

<style scoped lang="scss">
@font-face {
  font-family: "Noh Carborne";
  src: url("../../fonts/TUV Noh Carbone.ttf");
}
.form-btn {
  margin-bottom: 0px;
  margin-top: 30px;
}
::v-deep .form-btn .el-form-item__content {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.form-btn button {
  width: 100%;
}
.btnLogin {
  background-color: #9e1c1e;
  transition: 0.3s !important;
  color: #fff;
  border: none;
  font-size: 16px;
  box-shadow: 0px 8px 15px 0px rgba(0, 0, 0, 0.24);
}
.btnLogin:hover {
  background-color: #e0ab45;
}
.forgot-pass {
  cursor: pointer;
  padding-top: 10px;
}

.circle {
  display: block;
}
#login-page {
  background: url("../../img/gioi-thieu-background-grid.png") no-repeat center
      center,
    url("../../img/gioi-thieu-background-cloud.png") no-repeat center center,
    #9e1c1e;
  padding: 15px;
  background-size: cover;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  -ms-background-size: cover;
}

img {
  max-width: 100%;
}

.login-form {
  width: 100%;
}
.form-login {
  position: relative;
  .alert {
    display: flex;
    justify-content: end;
    position: absolute;
    top: -10px;
    right: -18px;
    div {
      background-color: #003168;
      color: #fff;
      padding: 5px;
      font-size: 16px;
    }
    i {
      margin-right: 10px;
      color: #ffc14e;
    }
  }
}
.form-login form {
  min-height: 410px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.content-w3ls {
  display: block;
  box-shadow: rgba(0, 0, 0, 0.4) 0px 30px 90px;
  background-color: #fff;
  width: 100%;
  position: relative;
}
.content-w3ls::before {
  content: "";
  position: absolute;
  background: url("../../img/gioi-thieu-hoa-trai.png");
  background-repeat: no-repeat;
  width: 207px;
  height: 224px;
  z-index: 10;
  left: -93px;
  bottom: -105px;
  display: none;
}
.content-w3ls::after {
  content: "";
  position: absolute;
  background: url("../../img/hoa-phai.png");
  background-repeat: no-repeat;
  width: 207px;
  height: 224px;
  z-index: 10;
  right: -202px;
  top: 68px;
  display: none;
}
.content-agile1 {
  background-color: #fff1dc;
  width: 50%;
  display: none;
  justify-content: center;
}
.content-agile2 {
  width: 100%;
}
.content-agile1,
.content-agile2 {
  position: relative;
}
.content-agile1::before,
.content-agile2::before {
  position: absolute;
  content: "";
  height: 13px;
  background: linear-gradient(
    180deg,
    #f9bc60 0%,
    #ffca78 20.31%,
    #fed9b7 53.12%,
    #fac96a 76.04%,
    #e0ab45 100%
  );
  left: 0;
  bottom: 0;
  width: 100%;
}
.content-logo {
  background-color: #003168;
  width: 250px;
  height: 350px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  box-shadow: 0 0 10px 0;
}
.content-logo h3 {
  font-size: 25px;
  font-family: "Noh Carborne";
  background: linear-gradient(
    270deg,
    #f9bc60 9.85%,
    #fed9b7 20.64%,
    #ffca78 42.94%,
    #fac766 55.11%,
    #fac96a 65.75%,
    #ffce87 84.81%,
    #e0ab45 99.18%
  );
  -webkit-background-clip: text;
  padding: 15px;
  margin-top: 20px;
  background-clip: text;
  color: transparent;
}

.title-login {
  background: #fff1dc;
  color: #9e1c1e;
  text-transform: uppercase;
  font-weight: bold;
  font-size: 25px;
  padding: 30px 30px;
}
.content-w3ls .content-agile2 .el-form {
  padding: 30px 40px;
}

::v-deep .el-checkbox__input.is-checked + .el-checkbox__label {
  color: #707276;
}
::v-deep .el-input__inner:focus {
  border-color: #c8ced3;
}

/*-- responsive design --*/
@media (min-width: 991px) {
  .content-w3ls {
    display: flex;
  }
  .content-w3ls::before {
    display: block;
  }
  .content-w3ls::after {
    display: block;
  }
  .content-agile1 {
    display: flex;
  }
  .content-agile2 {
    width: 50%;
  }
  #login-page {
    align-items: center;
  }
  .login-form {
    max-width: 900px;
  }
}
</style>
